import React from 'react';
import PropTypes from 'prop-types';
import './IronSightCards.css';

function PhotosTab({ unit, images, imagesLoading, setLightboxIndex }) {
    return (
        <div className="tab-content">
            {imagesLoading ? (
                <div className="photos-loading">
                    <div className="photos-spinner"></div>
                    <p>Loading photos...</p>
                </div>
            ) : images.length === 0 ? (
                <div className="empty-tab">
                    <p>No photos available for this unit.</p>
                </div>
            ) : (
                <div className="is-card photos-card">
                    <div className="is-card-body">
                        <h3 className="is-section-title">Photos</h3>
                        <p className="photos-count">{images.length} photo{images.length !== 1 ? 's' : ''} from the listing</p>
                        <div className="photos-grid">
                            {images.map((url, idx) => (
                                <button
                                    key={idx}
                                    className="photo-item"
                                    onClick={() => setLightboxIndex(idx)}
                                    aria-label={`View photo ${idx + 1}`}
                                >
                                    <img
                                        src={url}
                                        alt={`${unit.MAKE} ${unit.MODEL} — view ${idx + 1}`}
                                        className="photo-img"
                                        loading="lazy"
                                    />
                                </button>
                            ))}
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

PhotosTab.propTypes = {
    unit: PropTypes.object.isRequired,
    images: PropTypes.arrayOf(PropTypes.string),
    imagesLoading: PropTypes.bool,
    setLightboxIndex: PropTypes.func.isRequired,
};

PhotosTab.defaultProps = {
    images: [],
    imagesLoading: false,
};

export default PhotosTab;
